module.exports = __webpack_public_path__ + "img/comp.1da1e7e9.svg";